import * as React from 'react';
import { Button } from 'antd';

interface Props {
  currentPage: number;
  currentItemCount: number;
  onChange?: (page: number) => void;
}
export default class Pagination extends React.Component<Props> {
  handleNext = () => {
    this.handleChange(this.props.currentPage + 1);
  }

  handlePrev = () => {
    if (this.props.currentPage > 1) {
      this.handleChange(this.props.currentPage - 1);
    }
  }

  handleChange = (page: number) => {
    const { onChange } = this.props;
    if (onChange) {
      onChange(page);
    }
  }

  render() {
    const { currentPage, currentItemCount } = this.props;
    const range = ((currentPage - 1) * 50);
    return (
      <div className="pagingation">
        <Button icon="left" disabled={currentPage <= 1} onClick={this.handlePrev} />
        <span>{range + 1}</span>
        <span> - </span>
        <span>{range + currentItemCount}</span>
        <Button icon="right" disabled={currentItemCount < 50} onClick={this.handleNext} />
      </div>
    );
  }
}


// WEBPACK FOOTER //
// ./src/components/Pagination.tsx